import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import Input from '../../Input';
import Heading from '../../Heading';

import List from '../../lists/List';
import TipList from '../../../shared/TipList';

const Volunteer = ({ id, event }) => {
  const path = `${id}.items`;
  const { t } = useTranslation();

  return (
    <section>
      <Input
        name="heading"
        label={t('builder.sections.heading')}
        path={`${id}.heading`}
      />

      <List
        path={path}
        event={event}
        titlePath="title"
        subtitlePath="link"
        textPath="summary"
      />
    </section>
  );
};

export function VolunteerHeading({ id }) {
  const { t } = useTranslation();
  const tips = t('builder.tooltips.volunteerWorkTips', { returnObjects: true });

  return <Heading id={id} tooltip={<TipList tiplist={tips} />} />;
}

export default memo(Volunteer);
